<template>
  <h1 class="text-lg font-bold" data-test="TH1">
    <slot />
  </h1>
</template>
